export const finnhub = {
    url: 'https://finnhub.io/api/v1',
    apiKey: 'c4u263qad3iertukt040',
}

export const honeyBadgerConfig = {
    apiKey: 'hbp_rJhAMS2BfYuFesEQcoOtZDZcbDm8bA2NKJOA',
    environment: 'production'
}

export const firebaseConfig = {
    apiKey: "AIzaSyAMCmpWMmF-M4Fl5d8cdn8g9ie9miydoPE",
    authDomain: "hieupham2k1.firebaseapp.com",
    databaseURL: "https://hieupham2k1-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "hieupham2k1",
    storageBucket: "hieupham2k1.appspot.com",
    messagingSenderId: "97320748876",
    appId: "1:97320748876:web:7100602ec1262e0e36f1e9"
}

export const puppeteerApi = {
    url: 'https://chromium-function.azurewebsites.net/api/get-microsoft-token',
}

export const backendApi = {
    url: 'https://hieupham2k1-api.azurewebsites.net',
}

export const contentHost = 'https://hieupham2k1.vercel.app'